import { connect } from 'react-redux'
import pluralize from 'pluralize'
import { BabylistStoreIcon } from 'components/icons'
import { getRegItemsBabylistCount } from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  const count = getRegItemsBabylistCount(state)
  return count < 1 ? (
    'Add an item from the Babylist shop.'
  ) : (
    <>
      {count} {pluralize('item', count)} added from the Babylist Shop!
    </>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <BabylistStoreIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
